import React, { useCallback, useEffect, useMemo, useState } from "react"
import {
  getChats,
  getMessages,
  markGroupAsRead,
  putMessage,
} from "../../core/repository/ChatRepository"
import ChatScreen from "../../screen/ChatScreen"
import ModalAlert from "../../components/ModalAlert"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import { sort } from "fast-sort"
import { updateItem } from "../../core/firebase/functions"
import { storage } from "../../core/firebase"
import moment from "moment"
import Send from "../../core/communication"
import { useSelector } from "react-redux"
import { customToast } from "../../components/Toast"
import { isJson } from "../../core/utils/jsonVerify"
import { debounce } from "lodash"

const useOtherUser = (loggedUser = {}, scopeId, scopeType) => {
  const [tab, setTab] = useState(loggedUser.id)
  const [availableIds, setAvailableIds] = useState([])
  const chatIds = [
    // { id: "7e289002-3ee5-4dce-847f-2f979f25384f", name: "Bento" },
    // { id: "3c4189db-bb3d-4042-bb6e-23d1b0df1110", name: "Maya" },
  ]

  const getAvailableIds = async () => {
    const ids = [{ id: loggedUser.id, name: loggedUser.name }]

    // for await (const chatId of chatIds) {
    //   await Send.get(`/projects/users/${scopeId}/${chatId?.id}`, `scopeType=${scopeType}`)
    //     .then((result) => ids.push(chatId))
    //     .catch((e) => console.log("Chat não existe:", e))
    // }

    setAvailableIds(ids)
  }

  useEffect(() => {
    if (scopeId) {
      setTab(loggedUser.id)
      setAvailableIds([])
      getAvailableIds()
    }
    return () => setAvailableIds([])
  }, [scopeId])

  return [
    availableIds.map(({ id }) => id).filter((id) => id === tab)[0],
    availableIds.filter(({ id }) => id === tab)[0]?.name,
    tab,
    setTab,
    [
      { id: loggedUser.id, name: "Minhas Conversas" },
      ...availableIds.filter((item) => item?.id !== loggedUser?.id),
    ],
  ]
}

const ChatContainer = () => {
  const { scope, scopeType } = useScope()
  const loggedUser = useUser()
  const [chat, setChat] = useState(false)
  const [userId, userName, tab, setTab, tabOptions] = useOtherUser(loggedUser, scope?.id, scopeType)
  const tags = useSelector((state) => state.app.tags)
  const [reload, setReload] = useState(false)
  const [messages, setMessages] = useState([])
  const [selectedChatUser, setSelectedChatUser] = useState([])
  const [channels, setChannels] = useState([])
  const [values, setValues] = useState({})
  const [loading, setLoading] = useState(false)
  const [channelLoading, setChannelLoading] = useState(false)
  const [openPicker, setOpenPicker] = useState(false)
  const { users } = useUsers()
  const messageSortDesc = sort(messages).desc((u) => new Date(u.date * 1000))
  const messageSortAsc = sort(messages).asc((u) => new Date(u.date * 1000))
  const [read, setRead] = useState(false)
  const [modalFilterIsOpen, setModalFilterIsOpen] = useState(false)
  const [formatedTags, setFormatedTags] = useState([])
  const [selectedTag, setSelectedTag] = useState("")
  const [selectedTagException, setSelectedTagException] = useState("")
  const [usersByTagException, setUsersTagException] = useState([])
  const [tagsToFilter, setTagsToFilter] = useState(false)
  const [isQuickFilterActive, setIsQuickFilterActive] = useState(false)

  const createdAt = messageSortAsc
    .filter((item) => item.idChat === chat.id)
    .map((item) => {
      return {
        ...item,
        createdAt: moment(new Date(item && item.date && item.date.seconds * 1000)).format(
          "DD/MM/YYYY",
        ),
      }
    })
    .filter(function (a) {
      return !this[JSON.stringify(a.createdAt)] && (this[JSON.stringify(a.createdAt)] = true)
    }, Object.create(null))

  useEffect(() => {
    setChat(false)
    setMessages([])
    setChannels([])
  }, [scope && scope?.id])

  useEffect(() => {
    setReload(!reload)
  }, [messages && messages.length, scope?.id, users && users.length])

  useEffect(() => {
    setMessages([])
    setChat(false)
  }, [read])

  useEffect(() => {
    if (users && loggedUser?.id) {
      loadChannels(read)
    }
  }, [tab, scope?.id, users && users.length, loggedUser?.id, read])

  useEffect(() => {
    loadMessages((newMessages) => {
      setMessages((previous) => [
        ...newMessages.map((item) => {
          const project =
            chat &&
            Array.isArray(chat?.usersGroup) &&
            chat?.usersGroup?.find((ug) => ug?.userId === item?.fromUserId)
          const message =
            typeof item.message === "object" ? { ...item, message: item?.message?.message } : item

          return {
            ...message,
            idChat: chat.id,
            nameSender: project
              ? project?.name
              : !project && item.from === userId
              ? userName
              : message?.name,
          }
        }),
        ...previous,
      ])
    })
  }, [chat && chat.id])

  useEffect(() => {
    if (channels && channels.length > 0) {
      setFormatedTags(
        tags.map(({ name, id, project }) => ({
          value: id,
          label: project && project.description ? `${name} - ${project?.description}` : name,
        })),
      )
    }
  }, [channels])

  // Reset quick filter when tag filters are applied
  useEffect(() => {
    if (usersByTagException && usersByTagException.length > 0 && !isQuickFilterActive) {
      // Tag filters are applied but quick filter is not active, so it was applied through modal
      // Keep the behavior as is
    }
  }, [usersByTagException, isQuickFilterActive])

  const loadMessages = (callback) => {
    if (chat && chat.id) {
      // const userId = tab === 1 ? "3c4189db-bb3d-4042-bb6e-23d1b0df1110" : tab === 2 ? "7e289002-3ee5-4dce-847f-2f979f25384f" : loggedUser.id
      getMessages(
        chat.id,
        (array) => {
          callback(array)
          markGroupAsRead(userId, chat.id)
        },
        (updatedMessage) => {
          console.log({ updatedMessage }, "nova")
        },
        (e) => console.log("Error on retrive chats", e),
        chat.users,
      )
    }
  }

  const loadChannels = async (read) => {
    setChannelLoading(true)
    // if (users && users.length > 0) {
    const chats = await getChats(loggedUser.id, read)

    // const chatIds = chats.map((item) => item.id)
    // const groupIds = await Send.post("/projects/groups/projectGroupIds", { groupIds: chatIds })

    let allChats = chats.map((chat) => {
      // const group = groupIds?.find((item) => item?.projectGroupId === chat?.id) || {}
      // let usersGroup = isJson(group?.usersGroup) ? JSON.parse(group?.usersGroup) : []
      // const notLoggedUser =
      //   (usersGroup?.length === 2 &&
      //     usersGroup
      //       .filter((ug) => ug.userId !== loggedUser?.id)
      //       .map((item) => ({ ...item, id: item?.userId }))) ||
      //   []
      
      const usersGroup = []
      const notLoggedUser = []

      return {
        id: chat.id,
        name: notLoggedUser[0]?.name || chat?.name,
        id_creator: chat.id_creator.id,
        status: 1,
        unreadCount: chat.unreadCount,
        users: chat?.users,
        hasChat: true,
        isFinished: chat.isFinished,
        date: chat.latestMessage?.date?.toDate(),
        message: chat.latestMessage?.message,
        projectNames: chat?.projectNames,
        projectIds: chat?.projectIds,
        usersGroup,
        notLoggedUser,
      }
    })

    allChats = sort(allChats).desc((u) => u.date?.getTime())
    setChannels(allChats)

    // "latestMessage": {
    //   "readByUsers": [],
    //   "date": {
    //       "seconds": 1697031702,
    //       "nanoseconds": 169000000
    //   },
    //   "message": "Participar",
    //   "fromUserId": "71e77908-f104-4593-bf31-cf070ad56e8a"
    // },

    // const promise = await Promise.all(
    //   users.map((item) => getOrCreateChat(item, loggedUser.id, scope?.id)),
    // )
    // const newChannels = await Promise.all(promise).then((response) => response)
    // const channelSort = sort(newChannels).asc((u) => (u && u.date ? u.date : !u.date)) || []

    // let channelFormatted = await Promise.resolve(
    //   channelSort
    //     .map((channelItem) => channelItem.id && { ...channelItem, hasChat: true })
    //     .filter((item) => item),
    // )

    // const usersToInitChat =
    //   users &&
    //   users
    //     .map((user) => {
    //       const hasUserInChat = channelFormatted
    //         .map(
    //           (item) =>
    //             item?.users && item.users.length === 2 && item?.users.find((u) => u === user?.id),
    //         )
    //         .filter((item) => item)

    //       return !(hasUserInChat && hasUserInChat.length) && user
    //     })
    //     .filter((item) => item)

    // channelFormatted = [...channelFormatted, ...usersToInitChat]
    // const channelsToPush =
    //   channelFormatted &&
    //   channelFormatted.map((item) => {
    //     const newName =
    //       users?.filter(
    //         (row) =>
    //           item &&
    //           item.users &&
    //           item.users?.filter((all) => all !== loggedUser.id).find((all) => all === row.id),
    //       )[0] &&
    //       users?.filter(
    //         (row) =>
    //           item &&
    //           item.users &&
    //           item.users?.filter((all) => all !== loggedUser.id).find((all) => all === row.id),
    //       )[0]?.name

    //     return {
    //       ...item,
    //       name:
    //         newName ||
    //         item.name /* .includes('Grupo Geral') ? item.name : item.name.split("-")[1] ? item.name.split("-")[1] : item.name */,
    //     }
    //   })

    //   console.log({channelsToPush})
    // setChannels(channelsToPush)
    // }
    setChannelLoading(false)
  }

  const onChange = (field, value) => {
    setValues({ ...values, [field]: value })
  }

  const onChangeFilterTags = (field) => (value) => {
    const setValueAndFilters = (setter) => {
      setter(value ? value.value : "")
      setValues((values) => ({ ...values, [field]: value || "" }))
    }

    if (field === "tag") {
      setValueAndFilters(setSelectedTag)
    } else if (field === "tagException") {
      setValueAndFilters(setSelectedTagException)
    }
  }

  const loadusersByTagException = async () => {
    setChannelLoading(true)
    const response = await Send.post("/tags-user/except", {
      tagId: selectedTag,
      exceptTagId: selectedTagException,
      yesOrNot: tagsToFilter
    })

    if (response.length > 0) {
      setUsersTagException(response)
    } else {
      setUsersTagException([])
    }

    setChannelLoading(false)
  }

  const loadTags = () => {
    // Reset quick filter when applying tag filters from modal
    setIsQuickFilterActive(false)
    loadusersByTagException()
  }

  const onKeyPress = (e) => {
    if (e && e.key === "Enter") {
      onSendMessages()
    }
  }

  const onSendMessages = (e) => {
    if (values && values.message) {
      putMessage(chat.id, userId, userName, values.message, null, chat.users, chat.name)
    } else {
      if (values && values.audio && values.audio.file) {
        const dataReference = `UploadField/:idFile`
        const uniqueFilename = values.audio.file.name
        const storageRef = storage.ref(dataReference).child(uniqueFilename)

        const contentType = "audio/mpeg"
        const task = storageRef.put(values.audio.file, {
          contentType,
        })
        task
          .then(() => {
            storageRef.getDownloadURL().then((url) => {
              putMessage(
                chat.id,
                userId,
                userName,
                "Audio 📃",
                { remotePath: url, name: uniqueFilename, localPath: uniqueFilename, contentType },
                chat.users,
                chat.name,
              )
            })
          })
          .catch((error) => {
            console.log("Erro ao enviar áudio", error)
            customToast("Erro ao enviar áudio", "error")
          })
      }
    }
    setReload(!reload)
    setValues({ audio: { value: "" } })
  }

  const uploadFiles = async (file) => {
    const dataReference = "UploadField/:idFile"
    file.forEach((item) => {
      const name = item.name

      const uniqueFilename = imageNameUtils(name)
      const storageRef = storage.ref(dataReference).child(uniqueFilename)
      console.log("stor", storageRef)
      const task = storageRef.put(item)
      const contentType = file[0].type
      task.then(() => {
        storageRef.getDownloadURL().then((url) => {
          if (contentType && contentType.includes("image")) {
            putMessage(chat.id, userId, userName, "Imagem 🖼️", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            })
          } else if (contentType && contentType.includes("application")) {
            putMessage(chat.id, userId, userName, "Arquivo 📃", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            })
          } else if (contentType && contentType.includes("video")) {
            console.log("stor", url)
            putMessage(chat.id, userId, userName, "Video 📃", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            })
          } else if (contentType && contentType.includes("audio")) {
            putMessage(chat.id, userId, userName, "Audio 📃", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            })
          }
        })
      })
    })
    setReload(!reload)
  }

  const onDeleteMessage = async (message) => {
    ModalAlert.danger({
      title: "Excluir",
      text: "Você deseja mesmo excluir esta mensagem",
      onConfirm: async () => {
        if (chat && chat.id && message && message.id) {
          await updateItem(`groups/${chat.id}/messages`, { id: message.id, deleted: true })
          setMessages((messages) => [...[{ ...message, deleted: true }], ...messages])
          setOpenPicker(false)
        }
        setReload(!reload)
      },
    })
  }

  const newChat = async () => {
    if (scopeType !== "project") {
      customToast("Não é possível criar um chat sem selecionar um PROJETO", "error")
      return
    }

    setLoading(true)
    const usersNew = [{ id: userId }, chat]
    const group = await Send.post(`/projects/groups/${scope?.id}`, {
      user: userId,
      start_at: moment(new Date()).format("YYYY-MM-DD"),
      finish_at: "2040-01-01",
      status: 1,
      title: chat.name,
      image: "",
      project: scope?.id,
    }).then((response) => response)
    for (let i = 0; i < usersNew.length; i++) {
      await Send.post(`/projects/groups/user/${scope?.id}/${group.id}`, {
        group: group.id,
        user: usersNew[i].id,
        start_at: moment(new Date()).format("YYYY-MM-DD"),
        finish_at: "2040-01-01",
        status: 1,
        moderator: group.user === usersNew[i].id ? true : false,
      })
    }
    setChat(false)
    setReload(!reload)
    setLoading(false)
  }

  const onTab = (tab) => {
    setTab(tab)
    setChat(false)
    setMessages([])
  }

  const handleTagsToFilter = (e) => {
    setTagsToFilter(!tagsToFilter)
  }

  const onQuickFilterClick = () => {
    const newQuickFilterState = !isQuickFilterActive
    setIsQuickFilterActive(newQuickFilterState)
    
    if (newQuickFilterState) {
      // Clear any existing tag filters from modal first
      setSelectedTag("")
      setSelectedTagException("")
      setValues((values) => ({ ...values, tag: "", tagException: "" }))
    }
    
    // No need to call backend or set loading
    // The filtering will be done directly in the filteredChannels function
  }

/*   const debouncedResults = useMemo(() => {
    return debounce(onChange, 200)
  }, [])

  useEffect(() => {
    return () => {
      debouncedResults.cancel()
    }
  }) */

  return (
    <>
      <ChatScreen
        loggedUser={userId}
        channels={filteredChannels(channels, values, usersByTagException, isQuickFilterActive, loggedUser)}
        messages={removeDuplicates(messageSortDesc)}
        unreadMessage={unreadMessage(channels)}
        {...{
          chat,
          setChat,
          setTab,
          tab,
          tabOptions,
          onSendMessages,
          onKeyPress,
          onChange,
          onChangeFilterTags,
          values,
          loading,
          setOpenPicker,
          openPicker,
          onDeleteMessage,
          uploadFiles,
          newChat,
          onTab,
          createdAt,
          channelLoading,
          setRead,
          read,
          modalFilterIsOpen,
          setModalFilterIsOpen,
          selectedChatUser,
          tags: formatedTags,
          tagsToFilter,
          handleTagsToFilter,
          selectedTag,
          selectedTagException,
          loadTags,
          onQuickFilterClick,
          isQuickFilterActive,
        }}
      />
    </>
  )
}

export default ChatContainer

const unreadMessage = (channels) => {
  return channels.filter((item) => item.unreadCount === 1).length > 0
    ? channels.filter((item) => item.unreadCount === 1).length
    : ""
}

const removeDuplicates = (values) => {
  return values.filter(function (a) {
    const id = a && a.id ? a.id : a
    return !this[JSON.stringify(id)] && (this[JSON.stringify(id)] = true) /* && !a.deleted; */
  }, Object.create(null))
}

export const imageNameUtils = (filename) => {
  return `${filename}-${new Date()
    .toLocaleString("pt-BR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(/\//g, "-")
    .replace(" ", "")}.${(filename ? filename : "").split(".").pop()}`
}

const filteredChannels = (data, values, usersByTagException, isQuickFilterActive, loggedUser) => {
  let filteredUsers = (data && data?.filter((item) => item?.users?.length > 1)) || []

  if (values && values.search && values.search.value !== "") {
    filteredUsers = filteredUsers.filter(
      (item) => item && item.name?.toLowerCase().includes(values.search.value?.toLowerCase()),
    )
  }

  if (usersByTagException && usersByTagException.length > 0) {
    filteredUsers =
      filteredUsers &&
      filteredUsers.filter((item) => usersByTagException.some((user) => user.name === item.name))
  }

  // Apply quick filter for user's name in tags if active
  if (isQuickFilterActive && loggedUser && loggedUser.name) {
    const userName = loggedUser.name?.toLowerCase()
    filteredUsers = filteredUsers.filter((item) => {
      // Check if any of the item's tags contain the user's name
      if (item.tags && Array.isArray(item.tags)) {
        return item.tags.some(tag => 
          tag.name?.toLowerCase().includes(userName)
        )
      }
      return false
    })
  }

  return filteredUsers
}
